<mat-form-field appearance="outline" class="dataselect affilateheight rm-border pt-0"
  *ngIf="role == 'Admin'|| affilateList.length>1" data-tour="affiliate-selector">
  <mat-select [(ngModel)]="_service.selectedAffilate" placeholder="Select Affilate" (selectionChange)="affiliatchng()">
    @for (affilate of affilateList; track $index) {
    <mat-option [value]="affilate.affiliate_code">
      {{ affilate.affiliate_code }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>
<span class="printSpan" style="margin-right: 10px;"> {{ this._service.selectedAffilate}}</span>
<span class="printSpan">
  {{
    currentLanguage
  }}
</span>
<mat-form-field appearance="outline" class="dataselect languagechng rm-border pt-0"
  *ngIf="role == 'Admin'|| languageList.length>1" data-tour="language-selector">
  <mat-select [(ngModel)]="siteLanguage" (selectionChange)="changeSiteLanguage(siteLanguage)">
    @for (locale of languageList; track $index) {
    <mat-option [value]="locale.code">
      {{ locale.label }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>
